// docs: https://github.com/altostra/type-validations#readme
import { anyOf, objectOf } from "@altostra/type-validations";
import { number } from "@altostra/type-validations/lib/primitives";

export const isAppSettingsCustomEventUsageResult = anyOf(
  objectOf({
    custom_event_count: number,
    custom_event_max: number,
  }),
  objectOf({})
);
